import React from 'react';
import './Step3Logic.css';

const Step3Logic = ({ formData, onSetFormData }) => {
  const { ingestionSettings } = formData;

  const handleFileTypeToggle = (fileType) => {
    const fileTypes = ingestionSettings.fileTypes.includes(fileType)
      ? ingestionSettings.fileTypes.filter(t => t !== fileType)
      : [...ingestionSettings.fileTypes, fileType];
    
    onSetFormData({
      ...formData,
      ingestionSettings: { ...ingestionSettings, fileTypes }
    });
  };

  const handleChange = (field, value) => {
    onSetFormData({
      ...formData,
      ingestionSettings: { ...ingestionSettings, [field]: value }
    });
  };

  return (
    <div className="step-content">
      <h3 className="step-title">Ingestion settings</h3>
      
      <div className="ingestion-section">
        <div className="section-title">Source info</div>
        <div className="info-row">
          <span className="info-label">Dataset:</span>
          <span className="info-value">{formData.source?.name || 'N/A'}</span>
        </div>
        <div className="info-row">
          <span className="info-label">Source type:</span>
          <span className="info-value">Azure Blob</span>
        </div>
        <div className="info-row">
          <span className="info-label">Source path:</span>
          <span className="info-value">https://account.blob.core.windows.net/container/leases/</span>
        </div>
      </div>

      <div className="ingestion-section">
        <div className="section-title">File matching</div>
        <div className="form-field">
          <label>Path prefix (optional)</label>
          <input
            className="resui-input"
            type="text"
            placeholder="subfolder inside the container/bucket"
            value={ingestionSettings.pathPrefix}
            onChange={(e) => handleChange('pathPrefix', e.target.value)}
          />
        </div>
        <div className="form-field">
          <label>File types</label>
          <div className="file-types-checkboxes">
            {['PDF', 'DOCX', 'CSV', 'XLSX'].map((type) => (
              <label key={type} className="checkbox-label resui-checkbox">
                <input
                  type="checkbox"
                  className="resui-checkbox-input"
                  checked={ingestionSettings.fileTypes.includes(type.toLowerCase())}
                  onChange={() => handleFileTypeToggle(type.toLowerCase())}
                />
                <span className="resui-checkbox-mark" />
                <span className="resui-checkbox-label">{type}</span>
              </label>
            ))}
          </div>
        </div>
        <div className="form-field">
          <label>Filename pattern (optional)</label>
          <input
            className="resui-input"
            type="text"
            placeholder="e.g. .pdf or lease_.pdf"
            value={ingestionSettings.filenamePattern}
            onChange={(e) => handleChange('filenamePattern', e.target.value)}
          />
        </div>
        <div className="form-field">
          <label className="checkbox-label resui-checkbox">
            <input
              type="checkbox"
              className="resui-checkbox-input"
              checked={ingestionSettings.includeSubfolders}
              onChange={(e) => handleChange('includeSubfolders', e.target.checked)}
            />
            <span className="resui-checkbox-mark" />
            <span className="resui-checkbox-label">Include subfolders</span>
          </label>
        </div>
      </div>

      <div className="ingestion-section">
        <div className="section-title">New file detection</div>
        <div className="form-field">
          <select
            className="resui-select"
            value={ingestionSettings.dedupeStrategy}
            onChange={(e) => handleChange('dedupeStrategy', e.target.value)}
          >
            <option value="by-path">Skip files already processed (by path)</option>
            <option value="by-path-modified">Skip by (path + last modified)</option>
            <option value="reprocess">Reprocess everything each run</option>
          </select>
        </div>
      </div>

      <div className="ingestion-section">
        <div className="section-title">Ingestion behavior</div>
        <div className="form-field">
          <select
            className="resui-select"
            value={ingestionSettings.ingestionMode}
            onChange={(e) => handleChange('ingestionMode', e.target.value)}
          >
            <option value="append">Append new files to existing dataset</option>
            <option value="replace">Replace dataset each run (full rebuild)</option>
            <option value="new-dataset">Create a new dataset per run</option>
            <option value="new-dataset-folder">Create a new dataset per new folder/prefix</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Step3Logic;


